import { render, staticRenderFns } from "./RequestsFilesPage.vue?vue&type=template&id=9338e4e6&scoped=true"
import script from "./RequestsFilesPage.vue?vue&type=script&lang=js"
export * from "./RequestsFilesPage.vue?vue&type=script&lang=js"
import style0 from "./RequestsFilesPage.vue?vue&type=style&index=0&id=9338e4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9338e4e6",
  null
  
)

export default component.exports